import React from 'react';
import { styled } from '@this/constants/themes';

import Tooltip from '@this/shared/tooltip/tooltip';
import { reportError } from '@this/lib/bugsnag';
import type Transit from '../../../../domain/transit/transit2';

import TranslateIgnoreText from '../../../shared/text/translate_ignore_text';

type Props = {
  transit?: Transit;
  domesticAirPriceIndex: number | null | undefined;
  itemTestIdPrefix: string;
};

const ReserveConfirmTransitTr: React.FC<Props> = ({ transit, domesticAirPriceIndex, itemTestIdPrefix }) => {
  try {
    const shinkansenTooLate = false;

    if (!transit) return <span>-</span>;

    return transit.shinkansen && shinkansenTooLate ? (
      <ShinkansenTooLate>
        新幹線のチケットは郵送する必要がありますので出発の2日前以降のご予約は承っておりません。
      </ShinkansenTooLate>
    ) : (
      <>
        <div data-testid={`${itemTestIdPrefix}-route-value`}>
          <TranslateIgnoreText
            text={transit.legsummariesFromtoJrair ? transit.legsummariesFromtoJrair : transit.legsFromto}
          />
        </div>
        <TextDetail data-testid={`${itemTestIdPrefix}-selected-text-row`}>
          {transit.air === true ? (
            <>
              <div data-testid={`${itemTestIdPrefix}-selected-text-value`}>
                <TranslateIgnoreText text={transit.selectedText} />
              </div>
              {transit.prices &&
                domesticAirPriceIndex != null &&
                transit.prices[domesticAirPriceIndex] != null && (
                  <TicketSeatTypeArea>{`券種: ${
                    transit.prices[domesticAirPriceIndex].ticketCategory === 'changeable' ? '変更可' : '変更不可'
                  } 席種: ${transit.prices[domesticAirPriceIndex].seatType}`}</TicketSeatTypeArea>
                )}
            </>
          ) : (
            <div data-testid={`${itemTestIdPrefix}-selected-text-value`}>
              <TranslateIgnoreText text={transit.selectedText} />
            </div>
          )}
        </TextDetail>
        <TextDetail>
          {transit.parentItem?.railwayDistance && transit.shinkansen && !transit.package && (
            <TextKm>
              営業キロ
              <Tooltip width={300}>
                <TextKmDetail>
                  ※営業キロとは、鉄道における営業線の長さを示すキロ程のことであり、運賃計算などの基礎となる数字です。
                </TextKmDetail>
                <TextKmDetail>※営業キロは新幹線だけでなく在来線も含みます。</TextKmDetail>
              </Tooltip>
              ：<span data-wovn-ignore>{transit.parentItem.railwayDistance}</span>km
            </TextKm>
          )}
        </TextDetail>
        {!transit.package && (
          <>
            {transit.priceDetailArray.map((d, i) => (
              <PriceDetail key={i} data-testid={`${itemTestIdPrefix}-price-detail-${i}-row`}>
                <p data-testid={`${itemTestIdPrefix}-price-detail-${i}-title`}>{d.title}</p>
                <p data-testid={`${itemTestIdPrefix}-price-detail-${i}-value`}>{d.price}</p>
              </PriceDetail>
            ))}
          </>
        )}
      </>
    );
  } catch (e) {
    reportError(e);
    return null;
  }
};

const ShinkansenTooLate = styled.span`
  color: ${props => props.theme.redColor};
`;

const TicketSeatTypeArea = styled.div`
  margin-bottom: 10px;
`;

const PriceDetail = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-left: 100px;
`;

const TextDetail = styled.div`
  font-size: 0.9em;
  padding-left: 0.9em;
  font-weight: normal;
`;

const TextKm = styled.div`
  display: flex;
`;

const TextKmDetail = styled.p`
  padding-left: 1em;
  text-indent: -1em;
`;

export default ReserveConfirmTransitTr;
